import { render, staticRenderFns } from "./BedrockChatWidget.vue?vue&type=template&id=ac1ff592&scoped=true"
import script from "./BedrockChatWidget.vue?vue&type=script&lang=js"
export * from "./BedrockChatWidget.vue?vue&type=script&lang=js"
import style0 from "./BedrockChatWidget.vue?vue&type=style&index=0&id=ac1ff592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1ff592",
  null
  
)

export default component.exports